export default "__VITE_ASSET__D6JNN3eb__"